import Modal from "components/DesignSystem/Modal/Modal";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { useModal } from "hooks/useModal";
import { PLATFORM } from "constants/addons";
import Loader from "components/design/loader";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { TaxSubscriptionsListContent } from "./TaxSubscriptionModalContent";
import { CheckoutModal } from "components/CheckoutModal/CheckoutModal";

type TaxSubscriptionModalProps = {
  show: boolean;
  onClose: () => void;
  entityId: string;
  groupId: string;
};

export const TaxSubscriptionModal = ({
  show = true,
  onClose,
  entityId,
  groupId,
}: TaxSubscriptionModalProps) => {
  const { uuid: currentGroupId } = useCurrentGroupContext();
  const {
    data: subscriptionPlans,
    isLoading,
    isSuccess,
  } = useGetSubscriptionsQuery({
    groupId: groupId || currentGroupId,
    entityId,
    subscription_types: PLATFORM,
  });
  const taxSubscriptionDetails = subscriptionPlans?.at(0);
  const checkoutModal = useModal();
  return (
    <Modal.Root open={show} onOpenChange={onClose}>
      <Modal.Content size="large">
        <Modal.Header>
          <div className="t-w-full">
            <Modal.Title titleIcon={<Modal.Close />}>
              <div>Upgrade Your Plan </div>
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Async.Root
            isEmpty={!subscriptionPlans}
            isLoading={isLoading}
            isSuccess={isSuccess}
          >
            <Async.Empty>
              <Loader />
            </Async.Empty>
            <Async.Success>
              {taxSubscriptionDetails && (
                <section>
                  <TaxSubscriptionsListContent
                    price={taxSubscriptionDetails.amount}
                    type={taxSubscriptionDetails.subscription_name}
                    features={taxSubscriptionDetails.metadata?.comparison || []}
                    description={
                      taxSubscriptionDetails.metadata?.service_description || ""
                    }
                    onUpgrade={() => {
                      checkoutModal.open();
                    }}
                  />
                  <CheckoutModal
                    entityId={entityId}
                    type="subscription"
                    onClose={checkoutModal.close}
                    open={checkoutModal.isOpen}
                    subscription={taxSubscriptionDetails}
                    onSubscribed={() => {
                      checkoutModal.close();
                      onClose();
                    }}
                  />
                </section>
              )}
            </Async.Success>
          </Async.Root>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
